module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"annotationsTimeline.noAnnotations":"There are no annotations here yet."}}')
  delete Component.options._Ctor
}
